import { render, staticRenderFns } from "./StockValuationSummaryWithCost.vue?vue&type=template&id=3f1ad67c&"
import script from "./StockValuationSummaryWithCost.vue?vue&type=script&lang=js&"
export * from "./StockValuationSummaryWithCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports